import React from "react";
import ArticleCard from "../Components/ArticleCard";

// Article modules
import automating from "../articles/automating-elevated-tasks";
import pcapAnalyzer from "../articles/PCAP_Analyzer";
import lemurloot from "../articles/lemurloot";
import suricataBench from "../articles/suricata-bench";
import earthwormLab from "../articles/earthworm-lab";
import earthwormPygmyGoat from "../articles/earthworm-pygmy-goat";
import jaBenchAnyrunQuasar from "../articles/ja-bench-anyrun-quasar";
import griftGithubSeoMalware from "../articles/grift-github-seo-malware";

/**
 * Articles index — compact cards like Home, but with a small polish:
 * hover shadow and a GitHub pill on the image.
 */
export default function Articles() {
    const articles = [
        {
            title: griftGithubSeoMalware.title,
            path: "/articles/grift-github-seo-malware",
            imageSrc: griftGithubSeoMalware.image,
            summary: griftGithubSeoMalware.summary,
            tags: griftGithubSeoMalware.tags,
            repoUrl: griftGithubSeoMalware.repoUrl,
            category: griftGithubSeoMalware.category || "Threat Hunting",
        },
        {
            title: jaBenchAnyrunQuasar.title,
            path: "/articles/ja-bench-anyrun-quasar",
            imageSrc: jaBenchAnyrunQuasar.image,
            summary: jaBenchAnyrunQuasar.summary,
            tags: jaBenchAnyrunQuasar.tags,
            repoUrl: jaBenchAnyrunQuasar.repoUrl,
            category: "Tool",
        },
        {
            title: earthwormPygmyGoat.title,
            path: "/articles/earthworm-pygmy-goat",
            imageSrc: earthwormPygmyGoat.image,
            summary: earthwormPygmyGoat.summary,
            tags: earthwormPygmyGoat.tags,
            repoUrl: earthwormPygmyGoat.repoUrl,
            category: "Detection Engineering",
        },
        {
            title: earthwormLab.title,
            path: "/articles/earthworm-lab",
            imageSrc: earthwormLab.image,
            summary: earthwormLab.summary,
            tags: earthwormLab.tags,
            repoUrl: earthwormLab.repoUrl,
            category: earthwormLab.category || "Threat Emulation",
        },
        {
            title: suricataBench.title,
            path: "/articles/suricata-bench",
            imageSrc: suricataBench.image,
            summary: suricataBench.summary,
            tags: suricataBench.tags,
            repoUrl: suricataBench.repoUrl,
            category: suricataBench.category || "Tool",
        },
        {
            title: lemurloot.title,
            path: "/articles/lemurloot",
            imageSrc: lemurloot.image,
            summary: lemurloot.summary,
            tags: lemurloot.tags,
            repoUrl: lemurloot.repoUrl,
            category: lemurloot.category || "Threat Emulation",
        },
        {
            title: pcapAnalyzer.title,
            path: "/articles/pcap-analyzer",
            imageSrc: pcapAnalyzer.image,
            summary: pcapAnalyzer.summary,
            tags: pcapAnalyzer.tags,
            repoUrl: pcapAnalyzer.repoUrl,
            category: pcapAnalyzer.category || "Tool",
        },
        {
            title: automating.title,
            path: "/articles/automating-elevated-tasks",
            imageSrc: automating.image,
            summary: automating.summary,
            tags: automating.tags,
            repoUrl: automating.repoUrl,
            category: automating.category || "Windows",
        },
    ];

    return (
        <div className="mx-auto max-w-6xl px-4 py-8">
            <header className="mb-8">
                <h1 className="text-3xl font-extrabold text-slate-100">Articles</h1>
                <p className="mt-2 text-slate-300">
                    Deep dives, build notes, and hands-on labs.
                </p>
            </header>

            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-8">
                {articles.map((a) => (
                    <ArticleCard key={a.path} article={a} variant="articles" />
                ))}
            </div>
        </div>
    );
}
